import React, { useEffect, useState } from "react";
import DetailHeader from "../DetailsHeader/DetailHeader";
import Styles from "./Transactions.module.css";
import { useSelector } from "react-redux";
import { walletTransactionApi } from "../../../Services/Payments/PaymentApi";
import { getWalletAccountActivity } from "../../../Services/GNA/GetData";
import LoadMorePagination from "../../LoadeMore";

const Transactions = ({ walletId: walletIdProp }) => {
  const wallet = useSelector(
    (state) => state?.paymentSlice?.walletAccountActive,
  );

  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);

  const activeWalletId = walletIdProp || wallet?.id;

  useEffect(() => {
    setPage(0);
    setTransactions([]);
  }, [activeWalletId]);

  useEffect(() => {
    let mounted = true;
    async function fetchData() {
      try {
        setLoading(true);
        const res = walletIdProp
          ? await getWalletAccountActivity({ walletId: walletIdProp, currentPage: page, size: 20 })
          : await walletTransactionApi({ page, size: 20 });
        if (!mounted) return;
        if (res?.data?.code === 200) {
          const newData = res.data.data.page || [];
          setTransactions((prev) =>
            page === 0 ? newData : [...prev, ...newData],
          );
          const { totalPages, currentPage } = res.data.data;
          setHasMore(currentPage < totalPages - 1);
        } else {
          if (page === 0) setTransactions([]);
          setHasMore(false);
        }
      } catch (error) {
        if (mounted) console.error("Error fetching transactions:", error);
        if (mounted && page === 0) setTransactions([]);
        if (mounted) setHasMore(false);
      } finally {
        if (mounted) setLoading(false);
      }
    }
    fetchData();
    return () => {
      mounted = false;
    };
  }, [page, walletIdProp, wallet?.id]);

  const handleLoadMore = () => setPage((prev) => prev + 1);

  const handleSelect = () => {};

  function formatDateTime(dateTimeStr) {
    if (!dateTimeStr) return "";

    const [datePart, timePart] = dateTimeStr.split(" ");
    const [day, month, year] = datePart.split("-");

    const date = new Date(`${year}-${month}-${day}T${timePart}`);

    return date
      .toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      })
      .replace(",", "");
  }

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <DetailHeader
        heading={"Transactions"}
        handleSelect={handleSelect}
        list={
          [
            // { name: "All", value: "all", status: true },
            // { name: "Ongoing", value: "ongoing", status: false },
            // { name: "Completed", value: "completed", status: false },
            // { name: "Pending", value: "pending", status: false },
          ]
        }
      />
      <div className={Styles.tableMainElem}>
        <div
          className={`display_flex_row tableHeading ${Styles.headingMainTable}`}
        >
          <div style={{ width: "15%" }}>Self Listing</div>
          <div style={{ width: "15%" }}>Counterparty Name</div>
          <div style={{ width: "15%" }}>Contract Id</div>
          <div style={{ width: "15%" }}>Transaction Date</div>
          <div style={{ width: "15%" }}>Transaction Amount (₹)</div>
          <div style={{ width: "10%" }}>Type</div>
          <div style={{ width: "10%" }}>Action</div>
        </div>
        <div className={`scroll_bar_y ${Styles.viewMainElem}`}>
          <LoadMorePagination
            hasMore={hasMore}
            onLoadMore={handleLoadMore}
            loading={loading}
          >
            {transactions?.map((ele, index) => (
              <div
                key={ele?.id ?? index}
                className="display_flex_row tableDetails"
              >
                <div style={{ width: "15%" }}>
                  {ele?.listingId?.split("_")?.[0] || "-"}
                </div>
                <div style={{ width: "15%" }}>
                  <div>
                    {(ele?.counterPartyName === "UNKNOWN"
                      ? ""
                      : ele?.counterPartyName) || "-"}
                  </div>
                  {ele?.counterPartyListingId && (
                    <div style={{ fontSize: "8px" }}>
                      {ele?.counterPartyListingId || "-"}
                    </div>
                  )}
                </div>
                <div style={{ width: "15%" }}>
                  {ele?.bilateralContractUniqueId || "Not Generated"}
                </div>
                <div style={{ width: "15%" }}>
                  {formatDateTime(ele?.dateTime)}
                </div>
                <div style={{ width: "15%" }}>{ele?.amount?.toFixed(2)}</div>
                <div style={{ width: "10%" }}>
                  {ele?.paymentType?.split("_")?.join(" ") || "-"}
                </div>
                <div
                  style={{
                    width: "10%",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                  className={
                    ele?.activity === "CREDIT" || ele?.activity === "RELEASED"
                      ? "accepted"
                      : "rejected"
                  }
                >
                  {ele?.activity}
                </div>
              </div>
            ))}
          </LoadMorePagination>
        </div>
      </div>
    </div>
  );
};

export default Transactions;
